import React from 'react';

const ExpandIcon = ({ className, collapse }: { className?: string; collapse: boolean }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" stroke="black">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 10C18.5 14.6935 14.6944 18.5 10 18.5C5.30571 18.5 1.50003 14.6935 1.50003 10C1.50003 5.30491 5.30571 1.5 10 1.5C14.6944 1.5 18.5 5.30491 18.5 10V10Z"
      />
      {!collapse && <path d="M10 5.36349L10 14.6362" />}
      <path d="M14.6368 10L5.36403 10" />
    </g>
  </svg>
);

export default ExpandIcon;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundGuidePage/ExpandIcon.tsx